import React, { useState, useEffect } from 'react';
import { Search, FileText, Shield } from 'lucide-react';
import { processSteps } from '../mockData';
import { Card } from './ui/card';

const iconMap = { Search, FileText, Shield };

export const ProcessSlider = () => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % processSteps.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 bg-[#f5f7eb]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#383D3B] mb-4">Three Steps to a Registered Mark</h2>
          <p className="text-lg text-gray-600">From intake to approval, here is how we guide you through the process</p>
        </div>

        {/* Desktop View */}
        <div className="hidden md:grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {processSteps.map((step, index) => {
            const Icon = iconMap[step.icon];
            const isActive = index === currentStep;
            return (
              <Card key={step.id} className={`p-8 text-center transition-all duration-500 ${isActive ? 'shadow-xl scale-105 border-2 border-[#99AA38]' : 'shadow-md hover:shadow-lg'}`}>
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full mb-6 transition-colors ${isActive ? 'bg-[#99AA38] text-white' : 'bg-[#e8edc7] text-[#99AA38]'}`}>
                  <Icon className="h-8 w-8" />
                </div>
                <div className={`text-sm font-semibold mb-2 transition-colors ${isActive ? 'text-[#99AA38]' : 'text-gray-500'}`}>STEP {step.id}</div>
                <h3 className="text-2xl font-bold text-[#383D3B] mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </Card>
            );
          })}
        </div>

        {/* Mobile Slider */}
        <div className="md:hidden overflow-x-auto">
          <div className="flex gap-4 pb-4" style={{ scrollSnapType: 'x mandatory' }}>
            {processSteps.map((step) => {
              const Icon = iconMap[step.icon];
              return (
                <Card key={step.id} className="flex-shrink-0 w-full p-6 shadow-lg text-center" style={{ scrollSnapAlign: 'start' }}>
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#99AA38] text-white mb-6">
                    <Icon className="h-8 w-8" />
                  </div>
                  <div className="text-sm font-semibold text-[#99AA38] mb-2">STEP {step.id}</div>
                  <h3 className="text-2xl font-bold text-[#383D3B] mb-4">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Progress Indicators */}
        <div className="flex justify-center gap-2 mt-8">
          {processSteps.map((_, index) => (
            <button key={index} onClick={() => setCurrentStep(index)}
              className={`h-2 rounded-full transition-all ${index === currentStep ? 'w-8 bg-[#99AA38]' : 'w-2 bg-gray-300'}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
